import { AnalyticsEvent } from "./analyticsEvent";
class NewsletterSubmittedEvent extends AnalyticsEvent {
    public hashed_emailAddress: string;
    public hashed_firstname: string;
    public hashed_lastname: string;
    public postcode: string

    constructor(
        hashed_emailAddress: string,
        hashed_firstname: string,
        hashed_lasttname: string,
        postcode: string,
    ) {
        super();
        this.hashed_emailAddress = hashed_emailAddress;
        this.hashed_firstname = hashed_firstname;
        this.hashed_lastname = hashed_lasttname;
        this.postcode = postcode;


    }
}

export { NewsletterSubmittedEvent }